module.exports = __webpack_public_path__ + "static/media/13ITC3.d4fb2dc5.jpg";